import React, { useCallback } from "react";

import { faLock } from "@fortawesome/pro-solid-svg-icons/faLock";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Form from "antd/es/form";
import { useIntl } from "react-intl";

import { SelectField, TextField } from "@mapmycustomers/ui";

import useAnalytics from "@app/util/contexts/useAnalytics";

import styles from "./MainFields.module.scss";
import useLanguageOptions from "./useLanguageOptions";

interface Props {}

const MainFields: React.FC<Props> = () => {
  const intl = useIntl();
  const analyticIssuer = useAnalytics();

  const handleFieldsChangeAnalytics = useCallback(
    (name: string, value: string) => {
      analyticIssuer?.clicked([name], { [name]: value });
    },
    [analyticIssuer]
  );

  const languageOptions = useLanguageOptions(intl);

  return (
    <div className={styles.container}>
      <Form.Item name="fullName">
        <TextField
          label={intl.formatMessage({
            id: "settings.profile.fullName.title",
            defaultMessage: "Full Name",
            description: "Title of settings profile full name",
          })}
          onChange={(value) => handleFieldsChangeAnalytics("Full Name", value)}
        />
      </Form.Item>
      <Form.Item name="phone">
        <TextField
          label={intl.formatMessage({
            id: "settings.profile.phone.title",
            defaultMessage: "Phone number",
            description: "Title of settings profile phone",
          })}
          onChange={(value) => handleFieldsChangeAnalytics("Phone Number", value)}
        />
      </Form.Item>
      <Form.Item name="username">
        <TextField
          label={intl.formatMessage({
            id: "settings.profile.email.title",
            defaultMessage: "Email address",
            description: "Title of settings profile email",
          })}
          onChange={(value) => handleFieldsChangeAnalytics("Email Address", value)}
        />
      </Form.Item>
      <Form.Item
        label={intl.formatMessage({
          id: "settings.profile.locale.label",
          defaultMessage: "Language",
          description: "Title of select language settings",
        })}
        name="language"
      >
        <SelectField
          options={languageOptions}
          placeholder={intl.formatMessage({
            id: "settings.profile.locale.placeholder",
            defaultMessage: "(Select language)",
            description: "Placeholder of select language settings",
          })}
        />
      </Form.Item>
      <Form.Item className={styles.timezoneField} name="timezone">
        <TextField
          disabled
          label={intl.formatMessage({
            id: "settings.profile.timezone.title",
            defaultMessage: "My Timezone",
            description: "Title of settings device timezone",
          })}
          suffix={<FontAwesomeIcon icon={faLock} />}
        />
      </Form.Item>
      <div className={styles.textBelowField}>
        {intl.formatMessage({
          id: "settings.profile.timezone.text",
          defaultMessage: "Your timezone is captured from your device and cannot be adjusted here",
          description: "Text of timezone",
        })}
      </div>
    </div>
  );
};

export default MainFields;
